import { Set as ImmutableSet } from 'immutable';
import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import styledWithTheme from 'foundations-theming/utils';
/**
 * @description Manages inter/intra message spacing based on
 * position descriptors, adding more space between message
 * groups than between individual messages
 */
export default styledWithTheme.div.attrs({
  'data-test-id': 'spacing-wrapper'
})(({
  positionDescriptors = ImmutableSet(),
  theme
}) => {
  const spacing200 = theme.space['200'];
  const spacing250 = theme.space['250'];
  return {
    inlineSize: '100%',
    paddingBlockEnd: positionDescriptors.contains(LAST) ? spacing200 : theme.space['100'],
    paddingBlockStart: spacing200,
    paddingInline: spacing250,
    '@media screen and (max-width: 900px)': {
      paddingInline: 0
    }
  };
});